import { ElMessage, ElMessageBox } from "element-plus";
import { computed, reactive, ref } from "vue";
import { postDownload } from "@/utils";
import { queryTable, queryTotalInventory } from "@/api/inventory";

export default function useInventoryTable() {
  // 搜索表单ref
  const searchRef = ref(null);

  // 编辑ref
  const editRef = ref(null);

  // 搜索表单
  const searchData = reactive({
    warehouseId: null,
    warehouseIdList: [],
    categoryId: null,
    categoryIdList: [],
    name: null,
    number: null,
    brand: null,
    model: null,
    tissue: null,
    lowerQuantity: null,
    upperQuantity: null,
    alarm: null,
  });

  // 分页参数
  const pages = reactive({
    page: 1,
    size: 10,
    total: 0,
  });
  const handleSizeChange = (val) => {
    pages.size = val;
    pages.page = 1;
    getList();
  };
  const handleCurrentChange = (val) => {
    pages.page = val;
    getList();
  };
  const indexMethod = (index) => {
    // 计算连续序号
    return (pages.page - 1) * pages.size + index + 1;
  };
  // 表格列配置
  const columns = ref([
    {
      label: "物料编号",
      prop: "number",
      width: 150,
      showOverflowTooltip: true,
    },
    {
      label: "物料名称",
      prop: "name",
      width: 200,
      showOverflowTooltip: true,
    },
    {
      label: "物料类别",
      prop: "categoryName",
      width: 200,
      showOverflowTooltip: true,
    },
    {
      label: "品牌",
      prop: "brand",
      width: 120,
    },
    {
      label: "规格型号",
      prop: "model",
      width: 120,
    },
    {
      label: "单位",
      prop: "unit",
      width: 120,
    },

    {
      label: "仓库",
      prop: "warehouseNameList",
      width: 200,
      showOverflowTooltip: true,
    },
    {
      label: "库存数量",
      prop: "totalQuantity",
      width: 120,
      isCustomSort: true,
    },
    {
      label: "库存上限",
      prop: "upperLimit",
      width: 120,
    },
    {
      label: "库存下限",
      prop: "lowerLimit",
      width: 120,
    },
    {
      label: "库存单价",
      prop: "realTimeUnitPrice",
      width: 120,
    },
    {
      label: "预警类型",
      prop: "alarm",
      width: 120,
    },
    {
      label: "偏差数量",
      prop: "deviation",
      width: 120,
    },
    {
      label: "库存总价",
      prop: "totalCost",
      minWidth: 120,
    },
  ]);

  // 库存总数
  const totalInventoryCount = ref(0);

  // 表格数据
  const tableData = ref([]);

  // 表格遮罩
  const tableLoading = ref(false);

  // 获取库存总数
  const getTotalInventoryCount = () => {
    queryTotalInventory({
      ...searchData,
    }).then((res) => {
      totalInventoryCount.value = res.data || 0;
    });
  };

  // 获取列表数据
  const getList = () => {
    tableLoading.value = true;
    getTotalInventoryCount();
    let sortObj = formatSortParam(sortParams.value);
    queryTable({
      ...searchData,
      ...sortObj,
      page: pages.page,
      limit: pages.size,
      // warehouseId: searchData.warehouseIds.length > 0 ? searchData.warehouseIds.join(',') : '',
      // categoryId: searchData.categoryIds.length > 0 ? searchData.categoryIds.join(',') : ''
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 点击重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    searchData.lowerQuantity = null;
    searchData.upperQuantity = null;
    pages.page = 1;
    getList();
  };

  // 点击编辑
  const handleAdjust = (row, type) => {
    editRef.value?.handleDialogOpen({ row, type });
  };

  // 导出
  const handleExport = () => {
    ElMessageBox.confirm("确定导出库存数据吗？", "导出", {
      confirmButtonText: "导出",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        postDownload("/inventory/export", { ...searchData }, "库存管理.xlsx");
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  // 排序相关功能
  const sortParams = ref({
    sortField: "",
    sortOrder: "",
  });
  // 库存数量排序  true正序(ascs) false倒序(descs)
  // 转换函数
  const formatSortParam = (params) => {
    if (!params.sortField || !params.sortOrder) return "";
    // 映射排序方向
    const orderMap = {
      ascending: "ascs",
      descending: "descs",
      asc: "ascs",
      desc: "descs",
      null: "",
      undefined: "",
      "": "",
    };
    const order = orderMap[params.sortOrder] || "";
    if (!order) {
      return "";
    }
    let obj = {};
    obj[order] = params.sortField;
    return obj;
  };
  const handleSortChange = ({ column, prop, order }) => {
    // 更新排序参数
    sortParams.value.sortField = prop;
    sortParams.value.sortOrder = order;
    //重置到第一页
    pages.page = 1;
    // // 重新加载数据
    getList();
  };

  return {
    searchRef,
    searchData,
    columns,
    handleSortChange,
    totalInventoryCount,
    tableData,
    tableLoading,
    pages,
    handleSizeChange,
    handleCurrentChange,
    indexMethod,
    editRef,
    getList,
    handleReset,
    handleAdjust,
    handleExport,
  };
}
